import { connect } from 'react-redux';
import NewCashout from '../../../components/betslip/NewCashout';

import {
  selectRunner,
  requestCashout,
  subscribe,
  unsubscribe,
} from '@xanadu/ui-shared/modules/cashout/actions';

const mapDispatchToProps = {
  selectRunner,
  requestCashout,
  subscribe,
  unsubscribe,
};

function mapStateToProps(state, props) {
  const runner = state.getIn(['runner', props.runnerId]);

  const marketId = runner && runner.marketId;

  return {
    runner,
    status: state.getIn(['market', marketId, 'status']),
    request: state.getIn(['cashout', 'requests', props.runnerId]),
    requestSubmitTime: state.getIn(['cashout', 'requests', props.runnerId, 'submitTime']),
    requestDelay: state.getIn(['cashout', 'requests', props.runnerId, 'delay'])
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewCashout);
